import { useProductListProvider } from 'product-list/context/ProductListProvider/useProductListProvider'
import { usePreviousUrl } from 'product-list/hooks/usePreviousUrl/usePreviousUrl'
import { getNavigationType } from 'product-list/utils/getNavigationType'
import { clearProductListState } from 'product-list/utils/productListState'
import { referrerFromProductPage } from 'product-list/utils/referrerFromProductPage'
import { useEffect, useLayoutEffect } from 'react'

export const useRestorePosition = () => {
	const { name, restoreStoredState } = useProductListProvider()
	const previousUrl = usePreviousUrl()

	useLayoutEffect(() => {
		// If the page was restored from the cache, we can use native scroll restoration
		const handler = (event: PageTransitionEvent) => {
			if (event.persisted) {
				window.history.scrollRestoration = 'auto'
			}
		}

		// Initially disable native scroll restoration because we won't be able to
		// restore the scroll position correctly. We can restore it using bfcache if
		// available or manually handle the scroll position restoration.
		window.history.scrollRestoration = 'manual'
		window.addEventListener('pageshow', handler)
		return () => {
			window.removeEventListener('pageshow', handler)
		}
	}, [])

	useEffect(() => {
		// Verify that we are navigating back
		const navType = getNavigationType()
		if (navType !== 'back_forward') {
			return
		}

		// Try to restore the scroll position manually
		if (previousUrl && referrerFromProductPage(previousUrl)) {
			restoreStoredState()
		}
		clearProductListState(name)
	}, [name, previousUrl, restoreStoredState])
}
